<template>
    <el-dialog class="reason-dialog" title="填写原因" :close-on-click-modal="false" :visible.sync="visible" width="600px">
        <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="120px">
            <el-form-item label="薪资未发原因" prop="noPaySalaryReasonList">
                <m-Select :multiple="true" :optionArr="reasonOptions" :value="formData.noPaySalaryReasonList"
                :disabledOptions="disabledOptions"
                    @input="getSelect"></m-Select>
            </el-form-item>
            <el-form-item label="原因说明" prop="salaryReasonRemark">
                <el-input :rows="5" type="textarea" placeholder="请输入薪资未发原因" v-model="formData.salaryReasonRemark"
                    maxlength="1000" show-word-limit>
                </el-input>
            </el-form-item>
            <el-form-item label="附件">
                <div class="upload-wrap">
                        <el-input
                            v-model="formData.fileInfo.fileName"
                            placeholder="点击上传附件"
                            class="upload-wrap__input"
                            readonly></el-input>
                        <upload
                            uploadDisplayType="icon"
                            accept=".jpg,.png,.doc,.docx,.ppt,.pptx,.pdf,.xls,.xlsx"
                            class="upload-wrap__icon"
                            @uploadSuccess="uploadSuccess"></upload>
                        <el-button v-if="formData.fileInfo.fileUrl" class="preview-btn" type="text" @click="preview">
                            预览
                        </el-button>
                    </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" :loading="btnLoading" @click="save">保 存</el-button>
        </span>
    </el-dialog>
</template>
<script>
import mSelect from '@/components/lots/otpSelect2'
import upload from '../../../components/upload/Index.vue'
import { filePreview } from '@/utils/filePreview.js'
import { dictWithUrl } from '@/components/lots/api'
import { saveNoPaySalaryReason } from '../../../api/warehouseResourceManagement/loaderSalaryConfirm.js'
export default {
    components: { mSelect, upload },
    data() {
        return {
            rules: {
                noPaySalaryReasonList: [
                    { required: true, message: '请选择薪资未发原因', trigger: 'change' }
                ],
                salaryReasonRemark: [
                    { required: true, message: '请输入原因说明', trigger: 'change' }
                ],
            },
            visible: false,
            btnLoading: false,
            formData: {
                noPaySalaryReasonList: [],
                salaryReasonRemark: '',
                fileInfo: {
                    fileName: '',
                    fileUrl: '',
                    fileId: '',
                }
            },
            selectList: [],
            reasonOptions: [
                { label: '稽查', value: '2' },
                { label: '重大异常', value: '3' },
                { label: '已无薪资', value: '06' },
            ],
            //员工收款账户异常、装卸费未发放、手机号错误、已离职，其他，前端置灰
            disabledOptions: ['01', '04', '05', '07', '08'],
        }
    },
    methods: {
        uploadSuccess(data) {
            this.formData.fileInfo.fileId = data.data.data.id
            this.formData.fileInfo.fileName = data.data.data.localFileName
            this.formData.fileInfo.fileUrl = data.data.data.downUrl
        },
        preview() {
            const fileObj = {
                fileName: this.formData.fileInfo.fileName,
                fileId: this.formData.fileInfo.fileId,
                fileUrl: this.formData.fileInfo.fileUrl,
            }
            filePreview(fileObj)
        },
        init(selectList) {
            this.visible = true
            this.formData = {
                noPaySalaryReasonList: [],
                salaryReasonRemark: '',
                fileInfo: {
                    fileName: '',
                    fileUrl: '',
                    fileId: '',
                }
            }
            this.selectList = selectList
            this.$nextTick(() => {
                this.$refs['ruleForm'].resetFields()
            })
        },
        getSelect(data) {
            this.formData.noPaySalaryReasonList = data
        },
        save() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.btnLoading = true
                    saveNoPaySalaryReason({
                        confirmCodeList: this.selectList.map(v => v.confirmCode),
                        ...this.formData
                    }).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('保存成功')
                            this.visible = false
                            this.$emit('refresh')
                        }
                    }).finally(() => {
                        this.btnLoading = false
                    })
                }
            });
        }
    },
    mounted(){
        dictWithUrl('NO_PAY_SALARY_REASON').then(res => {
            if (res && +res.code === 0) {
                this.reasonOptions = Object.keys(res.data.NO_PAY_SALARY_REASON).reduce((t, v) => {
                    if(this.disabledOptions.includes(v)){
                        //禁用的放后面
                        t.push({label: res.data.NO_PAY_SALARY_REASON[v], value: v})
                    }else{
                        t.unshift({label: res.data.NO_PAY_SALARY_REASON[v], value: v})
                    }
                    return t
                }, [])
            }
        })
    }
}
</script>
<style lang="less" scoped>
.reason-dialog {
    .upload-wrap {
        position: relative;
        width: 264px;

        &__input {
            /deep/ .el-input__inner {
                padding-right: 30px;
                width: 264px;
            }
        }

        &__icon {
            position: absolute;
            right: 8px;
            bottom: 0;
            z-index: 9;
            color: #33c9cc;
        }

        .preview-btn {
            position: absolute;
            right: -30px;
            bottom: 5px;
            z-index: 9;
        }
    }
}
</style>